module.exports = __webpack_public_path__ + "static/media/product-detail-layout-button-two.3ec1adec.png";